import { HardDriveDownload, Home, LibraryBig, Settings, SlidersHorizontal, Wifi, WifiOff } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../features/language/LanguageSwitcher';
import { usePwa } from '../features/pwa/PwaProvider';
import { Brand } from './Brand';

function navClass({ isActive }: { isActive: boolean }): string | undefined {
  return isActive ? 'nav-link' : 'nav-link';
}

export function AppHeader() {
  const { t } = useTranslation();
  const { online, offlineReady } = usePwa();

  return (
    <>
      <a className="sr-only" href="#main-content">{t('navigation.skipToContent')}</a>
      <header className="app-header">
        <div className="content-wrap header-inner">
          <Brand />
          <nav className="desktop-nav" aria-label={t('navigation.allTools')}>
            <NavLink className={navClass} to="/" end>{t('navigation.home')}</NavLink>
            <NavLink className={navClass} to="/tools">{t('navigation.allTools')}</NavLink>
            <NavLink className={navClass} to="/settings/offline-storage">{t('navigation.offline')}</NavLink>
          </nav>
          <div className="header-actions">
            <span
              className="status-pill header-connectivity"
              data-tone={online ? 'positive' : 'attention'}
              title={online ? t('offline.connectivity.onlineDescription') : t('offline.connectivity.offlineDescription')}
            >
              {online ? <Wifi size={14} aria-hidden="true" /> : <WifiOff size={14} aria-hidden="true" />}
              <span className="header-online-label">{online ? t('offline.connectivity.online') : t('offline.connectivity.offline')}</span>
            </span>
            {offlineReady && <span className="status-pill header-online-label" data-tone="positive">{t('offline.readiness.ready')}</span>}
            <LanguageSwitcher className="header-language" />
            <NavLink className="icon-button header-settings" to="/settings" aria-label={t('navigation.settings')}>
              <Settings size={19} aria-hidden="true" />
            </NavLink>
          </div>
        </div>
      </header>
      <nav className="mobile-nav" aria-label={t('navigation.allTools')}>
        <NavLink to="/" end><Home size={18} aria-hidden="true" /><span>{t('navigation.home')}</span></NavLink>
        <NavLink to="/tools"><LibraryBig size={18} aria-hidden="true" /><span>{t('navigation.allTools')}</span></NavLink>
        <NavLink to="/settings/offline-storage"><HardDriveDownload size={18} aria-hidden="true" /><span>{t('navigation.offline')}</span></NavLink>
        <NavLink to="/settings"><SlidersHorizontal size={18} aria-hidden="true" /><span>{t('navigation.settings')}</span></NavLink>
      </nav>
    </>
  );
}
